<template>

  <div class="animated fadeIn">
    
  </div>
</template>

<script>


export default {
  name: 'dashboard',
  mounted() {
    
    //this.$notify.success('This is success message');
    //this.$notify.info('A message that should be displayed');
    //this.$notify.error('My HTML ');
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
